export default {
    login: {
        method: 'post',
        url: 'auth/login'
    },
    logout: {
        method: 'post',
        url: 'auth/logout'
    },
    getAccount: {
        method: 'get',
        url: 'account'
    },
    getAccountConfig: {
        method: 'get',
        url: 'account/config'
    },
    editAccount: {
        method:'post',
        url:'accounts'
    },
    listMedia: {
        method: 'get',
        url:'medias'
    },
    getMediaConfig: {
        method: 'get',
        url: 'media/config'
    },
    editMedia: {
        method:'post',
        url:'medias'
    },
    listAdzone: {
        method: 'get',
        url:'adzones'
    },
    getAdzoneConfig: {
        method: 'get',
        url: 'adzone/config'
    },
    editAdzone: {
        method: 'post',
        url: 'adzone'
    },
    getTableReport: {
        method: 'post',
        url: 'tableReport'
    },
    getChartReport: {
        method: 'post',
        url: 'chartReport'
    },
    getReportConfig: {
        method: 'get',
        url: 'reportConfig'
    }
}
